import { ApiType } from "@gymflow/common";
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { reportQueryKeys } from "../report";
import { leadQueryKeys } from "./leadQueryKeys";

export function useMutationEditLeadStatus(
  {
    api,
  }: {
    api: ApiType;
  },
  mutationOpts?: UseMutationOptions<
    unknown,
    unknown,
    { columnId: number; newName: string }
  >,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      columnId,
      newName,
    }: {
      columnId: number;
      newName: string;
    }) => api.leadApi.editStatusColumnName(columnId, newName),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: leadQueryKeys.all() });
      queryClient.invalidateQueries({ queryKey: reportQueryKeys.lead() });
    },
    ...mutationOpts,
  });
}
